import { staticText } from 'utils/staticText';

const money101Translation = staticText({
  show_all_banking_products: {
    _: 'Show All Products',
    zh: '顯示所有銀行戶口',
  },
  show_all_investment_products: {
    _: 'Show All Products',
    zh: '顯示全部證卷商',
  },
  sta_bka_bank_gift: {
    _: `Provider Gift - On Top of Money101`,
    zh: '銀行優惠',
  },
  offers: {
    _: 'Offers',
    zh: '申辦及達指定門檻即享有以下優惠:',
  },
  apply_through: {
    _: 'Apply through SingSaver and choose from :count premium rewards',
    zh: '透過 Money101 申請，享獨家通路好禮！ :count 項好禮擇一',
  },
  purchase_through: {
    _: 'Purchase through SingSaver and choose from :count premium rewards',
    zh: '透過 Money101 購買，享獨家通路好禮！ :count 項好禮擇一',
  },
  apply_through_stk_bka: {
    _: 'Apply through Money101 and choose from :count premium rewards (Actual Gift eligibility depends on the deposit amount provided in the terms and conditions)',
    zh: '透過 Money101 申請，享獨家通路好禮！ :count 項好禮擇一',
  },
  bank_gift: {
    _: `Bank Gift - On Top of Money101`,
    zh: '銀行優惠',
  },
  lender_gift: {
    _: `Lender Gift - On Top of Money101`,
    zh: '銀行優惠',
  },
  brand_reward_product_modal: {
    _: 'Money101 Reward',
    zh: 'Money101 精選優惠',
  },
  brand_reward_product_modal_cc: {
    _: 'Money101 Reward',
    zh: 'Money101 精選優惠',
  },
  brand_reward_stk_bka: {
    _: 'Money101 Reward',
    zh: 'Money101 好禮價值',
  },
  loan_reward_bank_gift: {
    _: `Your Loan Rewards & Bank Gifts`,
    zh: `你的貸款獨家好禮與銀行優惠`,
  },
  eligible_choose_reward: {
    _: `You’re eligible to choose one reward based on your loan amount and tenure`,
    zh: `根據你輸入的貸款金額及還款期限，你可以選擇以下其中一個優惠`,
  },
  eligible_choose_reward_without_tenure_and_amount: {
    _: `You’re eligible to choose one reward`,
    zh: `根據你輸入的貸款金額及還款期限，你可以選擇以下其中一個優惠`,
  },

  monthly_repayment: {
    _: 'Monthly Repayment',
    zh: '每月還款金額',
  },
  annual_interest_rate: {
    _: 'Annual Interest Rate',
    zh: '最低貸款利率',
  },
  APR: {
    _: 'APR',
    zh: '總費用年百分率',
  },

  loan: {
    _: 'Loan',
    zh: '貸款',
  },
  reward_modal_loan_amount_with_end: {
    _: ':start - :end',
    zh: '貸款金額 :start - :end',
  },
  reward_modal_loan_amount_without_end: {
    _: ':start and above',
    zh: '貸款金額 :start 或以上',
  },
  personal_loan_amount: {
    _: 'Loan Amount (:currency)',
    zh: '貸款金額 (:currency)',
  },
  personal_loan_tenure: {
    _: 'Tenure (months)',
    zh: '還款期限 (月)',
  },
  personal_loan_amount_help: {
    _: 'Most lenders offer loans between :currency:min_amount and :currency:max_amount depending on your profile.',
    zh: '大多數貸款機構提供的貸款金額範圍約為 :currency:min_amount 至 :currency:max_amount，實際核准金額將依申請人個人資料而定',
  },
  personal_loan_tenure_help: {
    _: 'Loan tenure ranges from :min_tenure to :max_tenure months. Longer tenures mean smaller monthly payments but more interest overall.',
    zh: '還款期限為 :min_tenure 到 :max_tenure 個月不等。還款期限越長，每月還款壓力較低，但總支付利息會較高。',
  },
  bank_gift_link: {
    _: `See the full welcome gift details`,
    zh: `查看更多優惠詳情`,
  },
  lightdeal: {
    _: 'Money101 Lightning Deal',
    zh: 'Money101 通路限定優惠',
  },

  standout_tips: {
    _: 'Money101 Tips',
    zh: 'Money101 理財建議',
  },
  standout_takeaways: {
    _: 'Money101 Takeaways',
    zh: 'Money101 重點',
  },
  standout_perspective: {
    _: 'Money101 Expert Perspective',
    zh: 'Money101 專家觀點',
  },
  loan_reward_lender_gift: {
    _: `Your Loan Rewards & Lender Gifts`,
    zh: `Money101申辦優惠資訊`,
  },
  loan_reward_provider_gift: {
    _: `Your Loan Rewards & Provider Gifts`,
    zh: `Money101申辦優惠資訊`,
  },
  lender_gift_info: {
    _: `You’ll also receive the following welcome gift(s) directly from the lender`,
    zh: `此產品享有以下限時優惠`,
  },
  loan_amount_exclusive_bold: {
    _: `For a <b>:product</b> of <b>:currency:amount</b> over <b>:tenure</b> months, you’ll enjoy via <b>:brand</b>`,
    zh: `申請 <b>:product</b> <b>:currency:amount</b> 分 <b>:tenure</b> 個月 攤還，並達成指定條件即享有以下優惠：`,
  },
  update_amount_tenure: {
    _: 'Update Loan Amount / Tenure to Qualify',
    zh: '調整貸款金額／還款期限以符合優惠資格',
  },
  update_amount_tenure_unlock_reward: {
    _: 'Update your loan amount to at least <b>:prefix:amount</b> and loan tenure to at least <b>:tenure month</b> to unlock exclusive gifts',
    zh: '內容：請將貸款金額調整至至少 <b>:prefix:amount</b> 或將還款期限延長至至少 <b>:tenure month</b> 達成指定條件即可獲得最高',
  },
  worth_up_reward: {
    _: '<b>worth up to :prefix:reward</b>',
    zh: '<b>:prefix:reward 專屬好禮</b>',
  },
  welcome_text_single: {
    zh: '獨家優惠限時享有！',
    _: '獨家優惠限時享有！',
  },
  welcome_text: {
    zh: '獨家優惠限時享有！',
    _: '獨家優惠限時享有！',
  },
});
export default money101Translation;
